import { startOfDay } from "date-fns";
import type { ReminderEntityConfig } from "web_myplann/Reminders/Config/reminderEntityConfig";
import type { ReminderTemplate } from "web_myplann/Reminders/Types/ReminderTypes";

export const getSelectableTemplates = (
	templates: ReminderTemplate[],
	entityConfig: ReminderEntityConfig,
	validTo: Date | null | undefined,
	today: Date | undefined = startOfDay(new Date()),
): ReminderTemplate[] => {
	const todayStart = startOfDay(today).getTime();

	return templates.filter((template) => {
		if (template.isCustom) {
			return entityConfig.allowCustom;
		}

		if (!entityConfig.resolveTemplateDate) {
			return true;
		}

		if (!validTo) {
			return false;
		}

		const date = entityConfig.resolveTemplateDate(template.typeKey, validTo);

		return date !== null && startOfDay(date).getTime() > todayStart;
	});
};
